import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class NewsletterPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.newsletterRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.newsletterImport,
    );
    this.newsletterAutocomplete = permissionChecker.match(
      Permissions.values.newsletterAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.newsletterCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.newsletterEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.newsletterDestroy,
    );
  }
}
